<template>
  <AcademicPlanVue/>
</template>

<script>
import AcademicPlanVue from '../../../components/academic/Advisor/AcademicPlan.vue'

export default {
components:{
    AcademicPlanVue
}
}
</script>

<style>

</style>